import Api from '@/services/Api'

const resource = 'prebecarios'

export default {
  listPrebecarios(listQuery) {
    return Api().get(resource, {
      params: {
        limit: listQuery.limit,
        offset: listQuery.limit * listQuery.page - listQuery.limit,
        ordering: listQuery.ordering,
        ...listQuery.filter,
      },
    })
  },
  listDocumentsPrebcario(key, conv) {
    return Api().get(`${resource}/documentos`, {
      params: {
        prebecario: key,
        tipo_convocatoria_id: conv,
      },
    })
  },
  addPrebecario(data) {
    return Api().post(`${resource}/registro/`, data)
  },
  savePrebecario(form) {
    return Api().post(`${resource}/`, form)
  },
  saveSolicitud(prebecario) {
    return Api().post(`${resource}/estatus/`, prebecario)
  },
  saveEstudios(form) {
    return Api().post(`${resource}/estudios/`, form)
  },
  saveDireccion(form) {
    return Api().post(`${resource}/direccion/`, form)
  },
  saveContacto(form) {
    return Api().post(`${resource}/contacto/`, form)
  },
  saveUniforme(form) {
    return Api().post(`${resource}/uniforme/`, form)
  },
  // saveDocumento(form) {
  //   return Api().post(`${resource}/documentos/`, form, {
  //     headers: {
  //       'Content-Type': 'multipart/form-data',
  //     },
  //   })
  // },
  saveDocumento(form) {
    return Api().post(`${resource}/uploadfile/`, form, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  deleteDocumento(data) {
    return Api().delete(`${resource}/uploadfile/`, { data })
  },
  uploadDocument(curp, data) {
    return Api().patch(`${resource}/documentos/${curp}/`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  updateDocumentValid(id, data) {
    return Api().patch(`${resource}/documentos/${id}/`, data)
  },
  getPrebecario(curp) {
    return Api().get(`${resource}/detalles/${curp}`)
  },
  getDataEmployee(id) {
    return Api().get(`${resource}/datos-empleado/${id}`)
  },
  setStatusSolicitud(form) {
    return Api().patch(`${resource}/estatus/${form.prebecario}/`, form)
  },
  exportData(filters) {
    return Api().get('export-data-v2', {
      params: { ...filters },
      responseType: 'arraybuffer',
    })
  },
  updateDatosPersonales(id, data) {
    return Api().patch(`${resource}/${id}/`, data)
  },
  updateDireccion(id, data) {
    return Api().put(`${resource}/direccion/${id}/`, data)
  },
  updateEstudios(id, data) {
    return Api().patch(`${resource}/estudiosupdate/${id}/`, data)
  },
  updateContacto(id, data) {
    return Api().patch(`${resource}/contacto/${id}/`, data)
  },
  updateUniforme(id, data) {
    return Api().patch(`${resource}/uniforme/${id}/`, data)
  },
  updateDomicilioNotificacion(id, data) {
    return Api().patch(`${resource}/domicilio/notificacion/${id}/`, data)
  },
  updateRejectSolicitud(data) {
    return Api().patch(`${resource}/update/reject/`, data)
  },
  updateFinishedSolicitud(data) {
    return Api().patch(`${resource}/update/finished/`, data)
  },
}
